import {CATEGORY_MAP, FALLBACK_CATEGORY} from '../consts/inbox-consts'
import type {CategoryDisplay, DeferredCategory} from '../types/list-types'

export function getCategoryDisplay(category: DeferredCategory): CategoryDisplay {
  return CATEGORY_MAP[category] ?? FALLBACK_CATEGORY
}
